/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AffiliateTypeEnum,
    AffiliateTypeEnumFromJSON,
    AffiliateTypeEnumFromJSONTyped,
    AffiliateTypeEnumToJSON,
} from './AffiliateTypeEnum';

/**
 * 
 * @export
 * @interface AffiliateDto
 */
export interface AffiliateDto {
    /**
     * 
     * @type {AffiliateTypeEnum}
     * @memberof AffiliateDto
     */
    type: AffiliateTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof AffiliateDto
     */
    rate: number;
    /**
     * 
     * @type {Date}
     * @memberof AffiliateDto
     */
    lastUpdated: Date;
}

export function AffiliateDtoFromJSON(json: any): AffiliateDto {
    return AffiliateDtoFromJSONTyped(json, false);
}

export function AffiliateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': AffiliateTypeEnumFromJSON(json['type']),
        'userId': json['userId'],
        'id': json['id'],
        'code': json['code'],
        'rate': json['rate'],
        'lastUpdated': (new Date(json['lastUpdated'])),
    };
}

export function AffiliateDtoToJSON(value?: AffiliateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': AffiliateTypeEnumToJSON(value.type),
        'userId': value.userId,
        'id': value.id,
        'code': value.code,
        'rate': value.rate,
        'lastUpdated': (value.lastUpdated.toISOString()),
    };
}

